import { FC, useMemo } from 'react';

import { BLOCK_TYPE_TO_COMPONENT_MAP } from '../../constants/blockComponent';
import { Block } from '../../types/Block';
import { BlockProps } from '../../types/BlockProps';

export const useBlock = (block: Block) => {
  const BlockComponent: FC<BlockProps<Block>> = useMemo(
    () => BLOCK_TYPE_TO_COMPONENT_MAP[block.type],
    [block.type],
  );

  return {
    Block: BlockComponent,
  };
};
